/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import Head from "next/head";
// import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getPrivacyPolicyData } from "../store/actions/privacyPolicyAction";


function FunWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
        function handleResize() {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
      }, []);
      return windowSize;
    }
const termsConditions = () => {
    const size = FunWindowSize();

    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getPrivacyPolicyData());
    }, [dispatch]);
    const privacyPolicyData = useSelector((state) => state.privacy_policy.privacy_policy.data);
    return (
        
        <div style={{ minHeight: size.height }}>
        <Head>
          <title>Residen | Privacy Policy</title>
        </Head>
        <Header />
        <div className="innerBannerWrapper">
          <div className="container">
            <div className="innerBannerCaption">
              <h1>{privacyPolicyData? privacyPolicyData[0].title: 'Privacy Policy'}</h1>
              <p>{privacyPolicyData? privacyPolicyData[0].meta_description: ''}</p>
            </div>
          </div>
        </div>
        <div className="padding-top padding-bottom aboutusWrapper">
        {(privacyPolicyData && privacyPolicyData.length>0) ? <>
          <div className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: privacyPolicyData[0].content }} />
           </>: null}
        </div>
        <Footer />
      </div>
    );
};

export default termsConditions;